import styled from '@emotion/styled';

export const FiltersWrapper = styled('div', { label: 'FiltersWrapper' })`
    padding: 20px 16px 16px 20px;
`;
